import React from 'react'
import _ from 'lodash'

import { reconfigButton } from '../../../utility'
import { getMixedProps, useDelayHandleChange } from './blockPublic'
import { useEventHandler, useInstData } from 'tyan/public/hooks'

import { Input, MultiLines } from './base'

const FormText = ({
	config: { field, onChange, initValues, changedValues, defaultStyle, that: { state: { _validStamp } } }
}) => {
	const { me } = useInstData(null)

	if (initValues[field.name] && typeof initValues[field.name] !== 'string') {
		console.warn(`The value of ${field.name}(${typeof initValues[field.name]}) must be a string`)
	}
	const { button: buttonPar, password, maxRows, richtext, list } = field

	let buttons = [].concat(buttonPar || []).map(button => reconfigButton(button))
	me.buttons = buttons = !_.isEqual(buttons, me.buttons) ? buttons : me.buttons
	// const { _button, text = _button, ui, icon = 'ellipsis-h', hidden = false, disabled = false, handler: buttonHandler } = button || {}

	// const height = useMemo(() => maxRows ? { height: maxRows * 15 + 18 } : {}, [maxRows])
	// const Comp = useMemo(() => maxRows ? TextAreaField : (password ? PasswordField : TextField), [maxRows, password])

	// clearable 多行文本默认 false, 否则 true
	let { props: { clearable, ...mixedProps } } = getMixedProps('_text', [defaultStyle, field])
	true && (clearable == undefined || clearable == null) && (clearable = maxRows ? false : true)
	me.mixedProps = mixedProps = _.isEqual(mixedProps, me.mixedProps) ? me.mixedProps : mixedProps
	const type = password ? 'password' : 'text'
	// console.log('mixedProps:', mixedProps)
	// console.log('buttons:', buttons)
	const delayChange = useDelayHandleChange(newValue => onChange({ name: field.name, newValue, type: 'string' }))
	const handleChange = useEventHandler((newValue, delay = true) => delay ? delayChange(newValue) : onChange({ name: field.name, newValue, type: 'string' }))

	return maxRows || richtext
		? <MultiLines {...mixedProps} {...{ type, field, onChange: handleChange, buttons, clearable, _validStamp }} />
		: <Input {...mixedProps} {...{ type, field, onChange: handleChange, buttons, clearable, _validStamp }} />
	// return <Comp {...mixedProps} {...height} {...{ onChange: handleChange, triggers, clearable }}
	// 	onErrorChange={(field, error) => that.setState(state => ({ formErrorCount: (state.formErrorCount || 0) + (error ? 1 : -1) }))}
	// />
}

const renderText = config => {
	// console.log('renderText')
	const { key } = config.field || {}
	return <FormText key={key} config={config} />
}

export default renderText